<template>
  <div id="active-plans">
    <b-row class="mt-4" v-if="loadingData && !loadError">
      <b-col
        v-for="(item, index) in 3"
        cols="12"
        md="6"
        lg="4"
        :key="item + index"
        class="mb-4"
      >
        <b-progress
          variant="primary"
          :max="100"
          class="w-100"
          show-progress
          animated
          height="200px"
        >
          <b-progress-bar :value="100">Loading...</b-progress-bar>
        </b-progress>
      </b-col>
    </b-row>
    <b-row v-else-if="loadError" class="mt-4" align-v="stretch">
      <b-col cols="12" class="mb-4">
        <div class="text-center" title="Could not load, click on retry">
          <b-button
            size="sm"
            @click="loadInvestments()"
            variant="light"
            class="w-100"
            style="height:200px"
          >
            <bad-network-icon />
            <br />Error Loading Data, <br />click to retry
            <reload-icon class="ml-1" />
          </b-button>
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-4" v-else align-v="stretch">
      <b-col
        cols="12"
        md="6"
        lg="4"
        class="mb-4"
        v-for="(subscription, index) in subscriptions"
        :key="subscription.amount + index"
      >
        <b-button
          @click="handleClicked(subscription)"
          variant="white"
          class="w-100 wrapper h-100 bg-white dash-card investment-blocks text-left p-0"
        >
          <div
            class="upper mb-1 bg-light p-4 text-white shadow-2xl"
            :style="{
              backgroundImage:
                ` linear-gradient(0deg, rgba(0,0,0,0.6), transparent), url(` +
                farm_img +
                `)`
            }"
          >
            <b-row align-h="between">
              <b-col cols="auto">
                <h5 class="text-white">
                  {{ subscription.location.locationname }} Farm<br />
                  <div style="font-size:15px; text-transform:capitalize">
                    {{ subscription.units }} units
                  </div>
                </h5>
              </b-col>
              <!--<b-col cols="auto" class="text-right">
                <i
                  class="fa fa-check-circle fa-lg text-primary"
                  aria-hidden="true"
                ></i>
              </b-col>-->
            </b-row>
          </div>
          <div class="upper p-4">
            <h4 class="mb-0">
              <Money
                class="text-primary mb-0"
                :value="subscription.amount || 0"
              />
            </h4>
            <small class="d-investment text-dark">
              Rented:
              {{
                LuxonDateTime.fromJSDate(
                  new Date(subscription.startdate)
                ).toFormat("LLL dd yyyy")
              }}
            </small>
            <hr class="mt-3" />
            <b-row align-h="between">
              <b-col>
                <b-button
                  variant="light"
                  @click="handleDetails(subscription)"
                  class="w-100 btn-sm"
                  >Details</b-button
                >
              </b-col>
              <b-col>
                <b-button
                  variant="primary"
                  @click="handleInvest(subscription)"
                  class="w-100 btn-sm"
                  >Farm For Me</b-button
                >
              </b-col>
            </b-row>
          </div>
        </b-button>
      </b-col>
    </b-row>
    <b-row v-if="subscriptions.length == 0">
      <b-col cols="12">
        <div
          class="d-flex bg-white dash-card p-5 align-items-center justify-content-center"
          style="height:200px"
        >
          <div class="wrap text-center">
            <h5 v-if="requests.length == 0">You have not rented any farm</h5>
            <b-button variant="primary" @click="$emit('setInvestTab')"
              >Rent a Farm</b-button
            >
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { DateTime as LuxonDateTime } from "luxon";
import { UserService } from "@/services";
import { formatMoney } from "@/utils/helpers";
import loadData from "@/mixins/loadData";
import FarmForMeSidebar from "./FarmForMeSidebar";
import FarmDetails from "./FarmDetails";

export default {
  data() {
    return {
      plots: [1, 2, 3, 4],
      plotSize: 1,
      requests: {},
      subscriptions: {},
      activeRequest: {},
      subscription: {},
      LuxonDateTime: LuxonDateTime,
      farm_img:
        "https://agbeloba-media.s3.amazonaws.com/057a2dc9-9714-40ad-8482-abf38fd629ca.jpg"
    };
  },
  mixins: [loadData],
  methods: {
    formatMoney,
    async loadInvestments() {
      this.loadingData = true;
      this.loadError = false;
      try {
        const { data } = await UserService.getFarmSubscriptions();
        let subscriptions = data.data.subscriptions;

        if (subscriptions.length == 0) {
          this.loadFarmRequests();
        }

        this.subscriptions = [];

        subscriptions.forEach(sub => {
          if (sub.package.type == "rental") {
            this.subscriptions.push(sub);
          }
        });
      } catch (err) {
        this.loadError = true;
      } finally {
        this.loadingData = false;
      }
    },
    handleInvest(subscription) {
      const panelResult = this.$showPanel({
        component: FarmForMeSidebar,
        openOn: "right",
        width: "400px",
        disableBgClick: true,
        props: {
          subscription: subscription
        }
      });

      panelResult.promise.then(result => {
        if (result.closedBy != "bg") {
          this.$emit("setActiveTab");
        }

        //result is the value passed from your component calling this.$emit('close-panel', //some value);
      });
    },
    handleDetails(subscription) {
      const panelResult = this.$showPanel({
        component: FarmDetails,
        openOn: "right",
        width: "400px",
        props: {
          subscription: subscription
        }
      });

      panelResult.promise.then(result => {
        if (result.closedBy != "bg") {
          this.$emit("setActiveTab");
        }

        //result is the value passed from your component calling this.$emit('close-panel', //some value);
      });
    },

    async getIndex(sub) {
      this.subscription = sub;
      // console.log(this.subscription);
    },
    async loadFarmRequests() {
      this.loadingData = true;
      this.loadError = false;
      try {
        const { data } = await UserService.getFarmRequests();

        let requests = data.requests;

        this.requests = [];

        requests.forEach(request => {
          if (request.package.type == "rental") {
            this.requests.push(request);
          }
        });
      } catch (err) {
        this.loadError = true;
      } finally {
        this.loadingData = false;
      }
    },
    handleClicked(subscription) {
      this.activeRequest = subscription.request;
      this.activeRequest.package = subscription.package;
      this.activeRequest.location = subscription.location;

      this.$bvModal.show("request-modal");
    }
  },

  mounted() {
    this.loadInvestments();
  }
};
</script>

<style>
.upper {
  background-size: cover;
  border-radius: 5px 5px 0 0;
}

.wrap small {
  font-size: 12px;
  font-weight: 700;
}

.wrap .d-block {
  font-size: 15px;
  font-weight: 700;
}
</style>
